import { render, staticRenderFns } from "./perseo_almacen_screen.vue?vue&type=template&id=72c54680"
import script from "./perseo_almacen_screen.vue?vue&type=script&lang=js"
export * from "./perseo_almacen_screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports